// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.goldbit",
    name: "GoldBit",
    homepage: "http://goldbit.io/gbapp.php",
    image_id: "11974ef1-21ab-4806-a2b1-362c31499900",
    app: {
        browser: null,
        ios: "https://apps.apple.com/tw/app/goldbit錢包/id1551914030",
        android: "https://play.google.com/store/apps/details?id=com.goldbitpro.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "goldbit://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map